import { resetAuthState } from "@funded-here-interface/common/src/features/auth/authSlice_Admin";
import { RefreshCooldownError } from "@funded-here-interface/common/src/hooks/useRefreshAuth";
import { SessionInvalidatedError } from "@funded-here-interface/common/src/Utils/axiosSessionInterceptor";
import { createUnauthorizedRedirectHandler } from "@funded-here-interface/common/src/Utils/unauthorizedRedirect";
import axios from "axios";
import { QueryClient } from "react-query";

import { store } from "../store";

const handleUnauthorizedRedirect = createUnauthorizedRedirectHandler(store, resetAuthState);

const handleOnError = (message: string) => {
  if (message === "Unauthorized") {
    handleUnauthorizedRedirect();
    return;
  }
};

// Global Axios interceptor — ensures raw Axios calls (outside React Query)
// also trigger logout on 401.
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      handleUnauthorizedRedirect();
    }
    return Promise.reject(error);
  },
);

const client = new QueryClient({
  defaultOptions: {
    mutations: {
      onError: (e) => {
        if (e instanceof SessionInvalidatedError) return;
        if (e instanceof RefreshCooldownError) return;
        handleOnError((e as Error).message);
      },
    },
    queries: {
      onError: (e) => {
        if (e instanceof SessionInvalidatedError) return;
        if (e instanceof RefreshCooldownError) return;
        handleOnError((e as Error).message);
      },
    },
  },
});

export { client };
